<template>
  <div :class="filterPairClasses">
    <div :class="filterFieldClasses">
      <slot name="first" />
    </div>

    <div
      v-if="showDivider"
      class="filter-bar__filter-divider filter-bar__filter-divider"
      v-html="divider"
    ></div>

    <div v-if="!singleSlot" :class="filterFieldClasses">
      <slot name="second" />
    </div>
  </div>
</template>

<script>
  import { buildClassString } from 'Utils'

  export default {
    data () {
      return {
        baseFilterBarClass: 'filter-bar',
      }
    },
    computed: {
      filterPairClasses () {
        const baseClass = `${this.baseFilterBarClass}__filter-pair`
        return buildClassString(baseClass, [
          {
            className: 'divided',
            testCondition: this.showDivider,
            bem: true,
          },
          {
            className: 'grid',
            testCondition: this.useGrid,
            bem: true,
          },
        ])
      },
      filterFieldClasses () {
        const baseClass = `${this.baseFilterBarClass}__filter-field`
        return buildClassString(baseClass, [
          {
            className: 'grid',
            testCondition: this.useGrid,
            bem: true,
          },
        ])
      },
    },
    props: {
      showDivider: {
        type: Boolean,
        default: false,
      },
      singleSlot: {
        type: Boolean,
        default: false,
      },
      divider: {
        type: String,
        default: '&ndash;',
      },
      useGrid: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
